<template>
	<div class="input__wrapper">
		<span class="checkbox-butons-title" :id="data.labelId">{{ data.label }}</span>
		<ul class="checkbox-butons">
			<li class="checkbox-butons-item" v-for="list in data.lists" :key="list.id">
				<input
					class="checkbox-list__input"
					type='checkbox'
					:id="list.id"
					:value="list.value"
					v-model="checkedList"
					>
				<label class="checkbox-list__label" :for="list.for">{{ list.label }}</label>
			</li>
		</ul>
	</div>
</template>
<script>
export default {
	props: {
		type: {
			type: String,
			default: 'text'
		},
		data: {
			type: Object,
			required: true
		}
	},

	data () {
		return {
			checkedList: [],
			checkbox: false
		};
	},

	watch: {
		checkedList (val) {
			this.$emit('input', val);
		}, 
		data: {
			handler(val) {
				const self = this;
				if (this.data.lists) {
					this.data.lists.forEach(d => { 
						if (d.checked) {
							self.checkedList.push(d.id);
						}
					});
				}
			},
			deep: true
		}
	},
	methods: {
		resetValue() {
			this.checkedList = [];
		}
	}
};
</script>
<style lang="scss" scoped>
.checkbox-butons-title {
	font-family: $font-main;
	font-size: 14px;
	line-height: 20px;
	color: $slate-gray;
	margin-bottom: 12px;
    display: block;
}

.checkbox-butons {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;

	@include mq(420px) {
		justify-content: space-between;
		flex-wrap: wrap;
	}
}

.checkbox-butons-item {
	display: flex;
	align-items: center;
	position: relative;
	line-height: 25px;

	&:not(:last-of-type) {
		margin-bottom: 15px;
	}
}

.checkbox-list__label {
	font-family: $font-main;
	display: flex;
	margin-bottom: 0;
	color: $fiord;
	font-size: 14px;
	line-height: 20px;
}

[type='checkbox']:checked,
[type='checkbox']:not(:checked) {
    position: absolute;
    left: -9999px;
}

[type='checkbox']:checked + label,
[type='checkbox']:not(:checked) + label {
    position: relative;
    padding-left: 33px;
    cursor: pointer;
    line-height: 20px;
	transition: $dur $ease;
    display: inline-block;

	@include mq($lg) {
		padding-left: 30px;
	}
}

[type='checkbox']:checked + label:before,
[type='checkbox']:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 4px;
    top: 0;
    width: 20px;
    height: 20px;
    border: 2px solid $white-lilac;
	box-sizing: border-box;
	border-radius: 4px;
    background: $white;
	transition: $dur $ease;

	@include mq($lg) {
		width: 15px;
		height: 15px;
	}
}

[type='checkbox']:checked + label:after,
[type='checkbox']:not(:checked) + label:after {
    content: '';
    position: absolute;
    left: 11px;
    top: 4px;
	width: 6px;
    height: 10px;
    transition: $dur $ease;
	border: solid $dodger-blue;
	border-width: 0 2px 2px 0;
	transform: rotate(45deg);

	@include mq($lg) {
		left: 9px;
		top: 2px;
		width: 4px;
		height: 9px;
	}
}

[type='checkbox']:not(:checked) + label:after {
    opacity: 0;
    transform: scale(0) rotate(45deg);
}

[type='checkbox']:checked + label:after {
    opacity: 1;
    transform: scale(1) rotate(45deg);
}

[type='checkbox']:checked + label:before {
	background: $white-lilac;
	border: 2px solid $white-lilac;
}
</style>
